import { createContext } from 'react';  
import { User } from './user';

export type Action = { type: 'SET_USER' };
export type Dispatch = (action: Action) => void;
export const UserContext = createContext<User | null>(null);
export const UserDispatchContext = createContext<Dispatch | null>(null);